/* LBScents - back to top
 *
 * Deliberately small: the element's only job is to toggle one class. Whether
 * the button can be focused is handled in CSS via `visibility`, which removes
 * it from the tab order while hidden - cheaper and more reliable than juggling
 * tabindex/aria-hidden, and it keeps behavior and appearance in one place.
 */
class LbsBackToTop extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    if (!this.button) return;

    // Show after roughly one viewport of scrolling, so the button never
    // appears on a page short enough not to need it.
    this.threshold = Number(this.dataset.threshold) || window.innerHeight * 0.8;
    this.ticking = false;

    this.onScroll = this.onScroll.bind(this);
    this.onClick = this.onClick.bind(this);

    window.addEventListener('scroll', this.onScroll, { passive: true });
    this.button.addEventListener('click', this.onClick);

    this.update();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.onScroll);
  }

  onScroll() {
    if (this.ticking) return;
    this.ticking = true;
    requestAnimationFrame(() => {
      this.update();
      this.ticking = false;
    });
  }

  update() {
    this.classList.toggle('lbs-back-to-top--visible', window.scrollY > this.threshold);
  }

  onClick() {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });

    // Scrolling alone leaves keyboard focus stranded at the bottom of the page,
    // so send it back to the top landmark to match what the user now sees.
    const target = document.querySelector('.header__heading-link') || document.body;
    target.setAttribute('tabindex', '-1');
    target.focus({ preventScroll: true });
    target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
  }
}

if (!customElements.get('lbs-back-to-top')) {
  customElements.define('lbs-back-to-top', LbsBackToTop);
}
